import Hero from "@/components/sections/Hero";
import IntakeBand from "@/components/sections/IntakeBand";
import ServiceCards from "@/components/sections/ServiceCards";
import SmartIntakePreview from "@/components/sections/SmartIntakePreview";
import MissedCallFollowup from "@/components/sections/MissedCallFollowup";
import AIReceptionist from "@/components/sections/AIReceptionist";
import LeadSummary from "@/components/sections/LeadSummary";
import MaintenancePlan from "@/components/sections/MaintenancePlan";
import ServiceArea from "@/components/sections/ServiceArea";
import Process from "@/components/sections/Process";
import FAQ from "@/components/sections/FAQ";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <IntakeBand />
      <ServiceCards />
      <SmartIntakePreview />
      <MissedCallFollowup />
      <AIReceptionist />
      <LeadSummary />
      <MaintenancePlan />
      <ServiceArea />
      <Process />
      <FAQ />
    </div>
  );
}
